"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Listener
 */

var noop = function noop() {};
var _listener = noop;

exports.default = {
  get listener() {
    return _listener;
  },
  listen: function listen(fn) {
    _listener = fn;
  },
  removeFluxListener: function removeFluxListener() {
    _listener = noop;
  }
};
module.exports = exports["default"];